module.exports = "https://static-production.npmjs.com/6bf09f9948c3044dbb2c7ed8b85098dc.png";